var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgExportUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 10C1.25 5.16751 5.16751 1.25 10 1.25C12.3206 1.25 14.5462 2.17187 16.1872 3.81282C17.8281 5.45376 18.75 7.67936 18.75 10C18.75 14.8325 14.8325 18.75 10 18.75C5.16751 18.75 1.25 14.8325 1.25 10ZM10 4.625C8.27411 4.625 6.875 6.02411 6.875 7.75C6.875 9.47589 8.27411 10.875 10 10.875C11.7259 10.875 13.125 9.47589 13.125 7.75C13.125 6.02411 11.7259 4.625 10 4.625ZM10 9.625C8.96447 9.625 8.125 8.78553 8.125 7.75C8.125 6.71447 8.96447 5.875 10 5.875C11.0355 5.875 11.875 6.71447 11.875 7.75C11.875 8.78553 11.0355 9.625 10 9.625ZM6.25 16.4875V15.2375C6.19289 14.1393 7.02782 13.1986 8.125 13.125H11.875C12.9747 13.1986 13.8107 14.1432 13.75 15.2437V16.4937C11.4323 17.8439 8.56771 17.8439 6.25 16.4937V16.4875ZM15 15.1938V15.5625C17.3178 13.4894 18.1159 10.2011 17.0063 7.29616C15.8967 4.39124 13.1096 2.47233 10 2.47233C6.89038 2.47233 4.10329 4.39124 2.99371 7.29616C1.88413 10.2011 2.68223 13.4894 5 15.5625V15.1938C4.96117 13.42 6.35208 11.9428 8.125 11.875H11.875C13.6464 11.9461 15.0355 13.4213 15 15.1938Z",
    fill: "#0F62FE"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgExportUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/export-user.6e9da9bdc2584e78f2e84a2dd24228b8.svg";